export const activeStaffSelector = (state) => state.staffReducer.active;
export const staffSelector = (state) => state.staffReducer.staffs;
export const searchSelector = (state) => state.staffReducer.search;
export const infosSelector = (state) => state.staffReducer.infos;

//detail
export const detailSelector = (state) => state.staffReducer.detail;
export const infoDetailSelector = (state) => state.staffReducer.infoDetail;

export const staffListSelector = (state) => state.staffReducer.staffList;

// all
export const allStaffsSelector = (state) => state.staffReducer.all;
